import React from 'react';
import { Flex, Grid, theme } from 'antd';

type Props = {
  back: React.ReactNode;
  primary?: React.ReactNode;
};

// Stacked on mobile with the primary action on top, so it is reached before
// the link that leaves the step.
function GscDomainPickerFooter({ back, primary }: Props) {
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Flex
      justify="space-between"
      align={isMobile ? 'stretch' : 'center'}
      gap={token.marginSM}
      style={{ flexDirection: isMobile ? 'column-reverse' : 'row' }}
    >
      {back}
      {primary}
    </Flex>
  );
}

export default GscDomainPickerFooter;
